import SvgPdf from '../../../others/svg_dist/Pdf';

/* Pliki trzeba opisywać manualnie, w przyszłości jeśli będzie taka potrzeba, można napisać skrypt */
export const filesMap = {
	info: [
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-05-21',
			size: '643 KB',
			title: 'Twój przewodnik po programie ubezpieczeń',
			href: '/downloads/wopr-broszura-program-ubezpieczen.pdf?v=1',
		},
		{
			icon: <SvgPdf />,
			editDate: '2024-11-25',
			size: '450 KB',
			title: 'Program WOPR - ulotka',
			href: '/downloads/wopr-ulotka.pdf?v=1',
		},
	],
	owu: [
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-05-21',
			size: '170 KB',
			title: 'Program ubezpieczenia',
			href: '/downloads/zalacznik1-ugu-program-ubezpieczenia-dla-ratownikow-wopr.pdf?v=1',
		},
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-04-17',
			size: '401 KB',
			title: 'Ogólne Warunki Ubezpieczenia OC i kosztów ochrony prawnej',
			href: '/downloads/oc-koszty-ochrony-prawnej-wu.pdf?v=1',
		},
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-04-17',
			size: '434 KB',
			title: 'Ogólne Warunki Ubezpieczenia NNW',
			href: '/downloads/nnw-owu-biznespodroz.pdf?v=1',
		},
	],
	forms: [
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-04-17',
			size: '57 KB',
			title: 'Formularz zgłoszenia szkody OC',
			href: '/downloads/formularz-zgloszenia-szkody-oc.pdf?v=1',
		},
		{
			icon: <SvgPdf className="icon__pdf" />,
			editDate: '2024-04-17',
			size: '78 KB',
			title: 'Formularz zgłoszenia wypadku NNW',
			href: '/downloads/formularz-zgloszenia-wypadku-nnw.pdf?v=1',
		},
	],
};
